import { localizeRoute, type LOCALIZED_PATHS } from '../constants/url-constants';

type AppLocale = keyof typeof LOCALIZED_PATHS;

/**
 * English logical salary hub path (`urlLogical` / Vike filesystem).
 */
export function salaryHubLogicalPath(): string {
  return '/salary';
}

/**
 * English logical salary role path (`urlLogical` / Vike filesystem).
 */
export function salaryRoleLogicalPath(roleSlug: string): string {
  return `/salary/${roleSlug}`;
}

/**
 * Full public salary hub path with locale prefix and localized segment (`/fi/palkka`, `/sv/lon`).
 * Mirrors companyProfileUrlPath's shape so it plugs into the same `<Link>` (which passes a
 * href through unchanged once it already carries a locale prefix) instead of double-localizing.
 */
export function salaryHubUrlPath(locale: AppLocale): string {
  return `/${locale}${localizeRoute(salaryHubLogicalPath(), locale)}`;
}

/**
 * Full public salary role path with locale prefix and localized segment
 * (`/fi/palkka/kokoonpanotyontekija`, `/sv/lon/…`).
 */
export function salaryRoleUrlPath(locale: AppLocale, roleSlug: string): string {
  return `/${locale}${localizeRoute(salaryRoleLogicalPath(roleSlug), locale)}`;
}
